import React from 'react';
import styles from './TitleBlock.module.scss';
import { Button, Flex } from 'antd';
import { ArrowUpRightIcon } from '@/shared/constants/icon';
import { useTranslations } from 'next-intl';
export function TitleBlock() {
  const t = useTranslations('welcome');
  return (
    <Flex className={styles.root}>
      <div className={styles.root_line}/>
      <h1>{t('title')}<span>{t('span')}</span></h1>
      <h2>{t('subtitle')}</h2>
      <Button className={styles.root_button} href="#ourProducts">{t('button')} <ArrowUpRightIcon size={'1dvw'}/></Button>
    </Flex>
  );
}
